export default __webpack_public_path__ + "static/media/greenExternalDns.304628c6.svg";